import * as React from "react";
const WorkshopPeopleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 19v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2m1-17.87a4 4 0 0 1 0 7.75M19 19v-2a4 4 0 0 0-3-3.85M3 5a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z"
    />
  </svg>
);
export default WorkshopPeopleIcon;
